<template>
  <div class="base-table spacey-12">
    <div class="table-header offers-table-columns grey-500 text-sm">
      <div>{{ $t('Offer version') }}</div>
      <div>{{ $t('Status') }}</div>
      <div>{{ $t('Date') }}</div>
      <div>{{ $t('Creator') }}</div>
    </div>
    <div v-for="offer in offers" :key="offer.id" class="table-row offers-table-columns">
      <div class="file-cell">
        <span class="text-sm file-title">{{ $t('v.') }}{{ offer.name }}</span>
      </div>
      <div class="file-cell">
        <Badge :color="OFFER_STATUS_BADGE[offer.status]">
          {{ tenderOfferVersionStatuses[offer.status] }}
        </Badge>
      </div>
      <div class="file-cell">
        <span class="text-sm">{{ prettyDates(offer.created_at, true) }}</span>
      </div>
      <div class="file-cell">
        <span class="text-sm">
          <span class="text-sm">{{ get(offer, 'author_user.name', '') }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatBytes } from '@/utils/formatting/format-bytes';
  import prettyDates from '@/utils/formatting/pretty-date';
  import Badge from '@/components/ui/Badge';
  import OFFER_STATUS_BADGE from '@/utils/constants/offer-status-badge';
  import get from 'lodash.get';
  import { mapState } from 'vuex';

  export default {
    name: 'OffersTable',
    components: {
      Badge,
    },
    props: {
      offers: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        OFFER_STATUS_BADGE,
      };
    },
    computed: {
      ...mapState('global', ['tenderOfferVersionStatuses']),
    },
    methods: {
      formatBytes,
      prettyDates,
      get,
    },
  };
</script>

<style scoped></style>
